/**
 * @param {string} creTs - wordpower email/link creation timestamp in milliseconds
 */

const validTime = (creTs: string): boolean => {
  const dayInMilliseconds = 86400000;
  const expirationPeriod = 10; // number of days until the link should expire

  const expirationDate =
    new Date(parseInt(creTs, 10)).getTime() +
    dayInMilliseconds * expirationPeriod;

  const currentDate = Date.now();

  return currentDate <= expirationDate;
};

export default validTime;
